






















































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import VipApi from '@/api/vip/list'
@Component({
  components: {
    CustomForm,
  },
})
export default class WithDrawalList extends AbpBase {
  filters = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '请输入昵称/手机号',
      },
      key: 'filter',
    },
    {
      label: '选择时间',
      type: 'datetimerange',
      key: 'dateTimeRange',
      props: {
        placeholder: '请选择时间范围',
      },
    },
  ]
  columns: any[] = [
    {
      title: '头像',
      slot: 'headImgUri',
      align: 'center',
    },
    {
      title: '昵称',
      key: 'nickName',
      align: 'center',
    },
    {
      title: '手机号',
      key: 'phoneNumber',
      align: 'center',
    },
    {
      title: '金额',
      slot: 'amount',
      align: 'center',
    },
    {
      title: '时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
  ]
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0

  submitChange(form, valid) {
    if (valid) {
      this.getTableData(form)
    }
  }

  mounted() {
    this.submitFn()
  }

  newSubmitFn() {
    this.currentPage = 1
    this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  /**
   * 获取储值审核列表
   */
  getTableData(form: any = {}) {
    // let filter = form['filter']
    let { pageSize, currentPage } = this
    let dateTimeRange = form['dateTimeRange'] ? form['dateTimeRange'] : [];
    let tempObj: any = {}
    if(dateTimeRange.length) {
      tempObj.Begin = dateTimeRange[0]
      tempObj.End = dateTimeRange[1]
    }
    tempObj.Filter = form.filter
    VipApi.getBalanceLogsDetail(pageSize, currentPage, tempObj)
      .then((res) => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }
  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }
}
